/** Group rows by a string key; sorts groups alphabetically (numeric-friendly). */
export function groupRowsBy<T>(rows: T[], getKey: (row: T) => string): { key: string; rows: T[] }[] {
  const map = new Map<string, T[]>();
  for (const row of rows) {
    const raw = getKey(row);
    const k = raw.trim() === '' ? '—' : raw;
    if (!map.has(k)) {
      map.set(k, []);
    }
    map.get(k)!.push(row);
  }
  return Array.from(map.entries())
    .sort((a, b) => a[0].localeCompare(b[0], undefined, { numeric: true, sensitivity: 'base' }))
    .map(([key, groupRows]) => ({ key, rows: groupRows }));
}
